import { render, staticRenderFns } from "./WorkflowTask.vue?vue&type=template&id=365c116e&"
import script from "./WorkflowTask.vue?vue&type=script&lang=js&"
export * from "./WorkflowTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports